import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Dashboard = () => {
    document.title = "DirtMap - Dashboards";

    const [subAdminList, setTotalSubAdminList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [sitePostList, setSitePostList] = useState([]);
    const [cmsPageList, setCmsPageList] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const totalSubAdmin = () => {
            axios.get(`/api/sub/admin/list`).then(res => {
                if (res.data.result) {
                    setTotalSubAdminList(res.data.result);
                }
                setLoading(false);
            });
        }
        const totalUser = () => {
            axios.get(`/api/user/list`).then(res => {
                if (res.data.result) {
                    setUserList(res.data.result);
                }
                setLoading(false);
            });
        }
        const totalListings = () => {
            axios.get(`/api/list/post/site`).then(res => {
                if (res.data.result) {
                    setSitePostList(res.data.result);
                }
                setLoading(false);
            });
        }
        const totalCmsPage = () => {
            axios.get(`/api/page/cms/list`).then(res => {
                if (res.data.result) {
                    setCmsPageList(res.data.result);
                }
                setLoading(false);
            });
        }
        const totalContact = () => {
            axios.get(`/api/contact/list`).then(res => {
                if (res.data.result) {
                    setContactList(res.data.result);
                }
                setLoading(false);
            });
        }
        totalSubAdmin();
        totalUser();
        totalListings();
        totalCmsPage();
        totalContact();
    }, []);

    var computedSubAdminList = subAdminList;
    var subAdminCount = computedSubAdminList.length

    var computedUserList = userList;
    var userCount = computedUserList.length

    var computedCmsPageList = cmsPageList;
    var cmsPageCount = computedCmsPageList.length

    var computedSitePostList = sitePostList;
    var siteCount = computedSitePostList.length

    var computedContactList = contactList;
    var contactCount = computedContactList.length
    return (
        <div id="content">
            <div className="container-fluid">
                <div className="row">

                    <div className="col-xl-3 col-md-6 mb-4">
                        <div className="card border-left-primary shadow h-100 py-2">
                            <Link to="/admin/sub-admin/index">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                Total Sub Admin</div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800">{subAdminCount}</div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-users fa-2x text-gray-300"></i>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 mb-4">
                        <div className="card border-left-primary shadow h-100 py-2">
                            <Link to="/admin/user/index">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                Total Users
                                            </div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800">
                                                {
                                                    userCount
                                                }
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-users fa-2x text-gray-300"></i>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 mb-4">
                        <div className="card border-left-primary shadow h-100 py-2">
                            <Link to="/admin/post-site/index">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                Total Listings</div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800">{siteCount}</div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-globe fa-2x text-gray-300"></i>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 mb-4">
                        <div className="card border-left-primary shadow h-100 py-2">
                            <Link to="/admin/page/index">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                Total Cms Pages</div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800">{cmsPageCount}</div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-file fa-2x text-gray-300"></i>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 mb-4">
                        <div className="card border-left-primary shadow h-100 py-2">
                            <Link to="/admin/contact/list">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                Total Contacts</div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800">{contactCount}</div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-address-book fa-2x text-gray-300"></i>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {/* <div className="col-xl-8 col-lg-7">
                        <div className="card shadow mb-4">
                            <div
                                className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                <h6 className="m-0 font-weight-bold text-primary">Earnings Overview</h6>
                                <div className="dropdown no-arrow">
                                    <Link className="dropdown-toggle" to="#" role="button" id="dropdownMenuLink"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                                        aria-labelledby="dropdownMenuLink">
                                        <div className="dropdown-header">Dropdown Header:</div>
                                        <Link className="dropdown-item" to="#">Action</Link>
                                        <Link className="dropdown-item" to="#">Another action</Link>
                                        <div className="dropdown-divider"></div>
                                        <Link className="dropdown-item" to="#">Something else here</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="chart-area">
                                    <canvas id="myAreaChart"></canvas>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* <div className="col-xl-4 col-lg-5">
                        <div className="card shadow mb-4">
                            <div
                                className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                <h6 className="m-0 font-weight-bold text-primary">Users Revenue Sources</h6>
                                <div className="dropdown no-arrow">
                                    <Link className="dropdown-toggle" to="#" role="button" id="dropdownMenuLink"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                                        aria-labelledby="dropdownMenuLink">
                                        <div className="dropdown-header">Dropdown Header:</div>
                                        <Link className="dropdown-item" to="#">Action</Link>
                                        <Link className="dropdown-item" to="#">Another action</Link>
                                        <div className="dropdown-divider"></div>
                                        <Link className="dropdown-item" to="#">Something else here</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="chart-pie pt-4 pb-2">
                                    <canvas id="myPieChart"></canvas>
                                </div>
                                <div className="mt-4 text-center small">
                                    <input type="hidden" name="direct_user_count" id="__directUserCount" value="0" />
                                    <input type="hidden" name="referral_user_count" id="__referralUserCount" value="0" />
                                    <span className="mr-2">
                                        <i className="fas fa-circle text-primary"></i> Direct
                                    </span>
                                    <span className="mr-2">
                                        <i className="fas fa-circle text-success"></i> Social
                                    </span>
                                    <span className="mr-2">
                                        <i className="fas fa-circle text-info"></i> Referral
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>

    )
}

export default Dashboard;